
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function TeamValues() {
  const titleRef = useScrollAnimation();

  // Create refs for all value cards at the top level
  const valueRefs = [
    useScrollAnimation(),
    useScrollAnimation(),
    useScrollAnimation(),
    useScrollAnimation(),
    useScrollAnimation(),
    useScrollAnimation()
  ];

  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Integrity First',
      description: 'We operate with complete transparency and honesty, always putting your interests ahead of our own. You can trust us to provide unbiased recommendations.'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Client-Focused Service',
      description: 'Every client receives personalized attention and customized solutions. We take the time to understand your unique situation and needs.'
    },
    {
      icon: 'ri-book-open-line',
      title: 'Expert Knowledge',
      description: 'Our team stays current on all health insurance regulations, plan changes, and industry trends to provide you with the most accurate information.'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Compassionate Care',
      description: 'We understand that health insurance can be confusing and stressful. We approach every interaction with patience, empathy, and understanding.'
    },
    {
      icon: 'ri-time-line',
      title: 'Responsive Support',
      description: 'When you need help, we\'re here. We pride ourselves on quick response times and being available when you have questions or concerns.'
    },
    {
      icon: 'ri-community-line',
      title: 'Community Commitment',
      description: 'As a Dallas-based agency, we\'re invested in our community. We support local businesses and give back to the neighborhoods we serve.'
    }
  ];

  return (
    <section className="py-20 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <h2 
          ref={titleRef.ref}
          className={`text-4xl md:text-5xl font-serif font-bold text-center text-primary mb-4 transition-all duration-1000 ${
            titleRef.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          What Sets Us Apart
        </h2>
        <p className="text-center text-lg text-gray-600 mb-16 max-w-3xl mx-auto">
          Our core values guide everything we do and define how we serve our clients
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => {
            const cardRef = valueRefs[index];
            
            return (
              <div 
                key={index}
                ref={cardRef.ref}
                className={`bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-all duration-500 ${
                  cardRef.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mb-6">
                  <i className={`${value.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-primary mb-4">{value.title}</h3>
                <p className="text-gray-700 leading-relaxed">{value.description}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-16 bg-white rounded-lg p-8 md:p-12 shadow-lg">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-serif font-bold text-primary mb-4">Meet Our Team</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Our team of licensed insurance professionals brings decades of combined experience in health insurance. Each team member is committed to staying current on industry changes and providing exceptional service.
              </p>
              <p className="text-gray-700 leading-relaxed mb-6">
                We're not just insurance agents – we're your neighbors, your advocates, and your partners in finding the right health coverage. When you work with us, you get a dedicated team that truly cares about your well-being.
              </p>
              <a
                href="/contact"
                className="inline-flex items-center gap-2 bg-accent text-white px-8 py-3 rounded-lg font-semibold hover:bg-accent/90 transition-colors whitespace-nowrap cursor-pointer"
              >
                Schedule a Meeting
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
            <div className="relative h-[400px] rounded-lg overflow-hidden shadow-xl">
              <img
                src="https://public.readdy.ai/ai/img_res/32857f901d3857629aab2d454696b241.jpg"
                alt="Our Professional Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
